/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "./form";

const {
  formField: {
    name,
      formula,
      description,
      brand,
      image_name,
      price,
      cost,
      fee_percent,
      discount_percent
  },
} = checkout;

const initialValues = {
  [name.name]: "",
  [formula.name]: "",
  [description.name]: "",
  [brand.name]: "",
  [image_name.name]: "",
  [price.name]: "",
  [cost.name]: "",
  [fee_percent.name]: "",
  [discount_percent.name]: "",
};

export default initialValues;
